import { render } from "./manage-edit.vue?vue&type=template&id=0c50c0e0"
import script from "./manage-edit.vue?vue&type=script&lang=js"
export * from "./manage-edit.vue?vue&type=script&lang=js"

import "./manage-edit.vue?vue&type=style&index=0&id=0c50c0e0&lang=css"

import exportComponent from "/Users/aun/Development/thailand-fest/thai-festival-admin-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__